import { useMemo } from 'react';
import noop from 'lodash/noop';

import useScreen from '@lyearn/core/hooks/useScreen';
import { CloseOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { BottomSheet, DeprecatedIconButton, Dialog } from '@lyearn/ui';

import { setMaxHeight, setWidth } from './styles';
import { DialogRootProps } from './types';

const bottomSheetClasses = { paperAnchorBottom: 'bg-transparent' };
const dialogPaperClassname = `bg-bg-primary rounded-16 relative shadow-04 m-0 overflow-hidden transform-gpu`;

const defaultRenderCloseButton = (onClose: VoidFunction) => (
  <DeprecatedIconButton
    Icon={CloseOutline}
    appearance="secondary"
    className="absolute top-12 end-12"
    shape="pill"
    size="large"
    variant="ghost"
    onClick={onClose}
  />
);

const DialogRoot = (props: DialogRootProps) => {
  const { isMobile } = useScreen();
  const {
    children,
    open = true,
    maxHeight,
    renderCloseButton = defaultRenderCloseButton,
    width,
    onClose,
  } = props;

  const dialogClasses = useMemo(
    () => ({
      paper: cn(dialogPaperClassname, setWidth(width), maxHeight && setMaxHeight(maxHeight)),
    }),
    [maxHeight, width],
  );

  if (isMobile) {
    return (
      <BottomSheet classes={bottomSheetClasses} open={open} onClose={onClose} onOpen={noop}>
        {children}
      </BottomSheet>
    );
  }

  return (
    <Dialog classes={dialogClasses} open={open} onClose={onClose}>
      {renderCloseButton(onClose)}
      {children}
    </Dialog>
  );
};

export default DialogRoot;
